<template>
  <div class="" style="position:fixed">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-container fluid style="padding-top: 100px;text-align:left">
          <b-row>
            <b-col cols="12 headerF"><HeaderConsumer/></b-col>
            <b-col cols="12 headerM"><HeaderConsumerMobile/></b-col>
          </b-row>

  <br>

        <b-row style="width:100vw">
                <b-col col cols="12" sm="3" md="3" lg="3" class="sideNav">
                    <AdminSideNav />
                </b-col>
                <b-col col cols="12" sm="12" md="9" lg="9" style="height:78vh; overflow-y:scroll " class="shadow">
                  <b-row>
                    <b-col col cols="12" sm="12" md="12" lg="12">
                     <h1 class="heading">Complaint Status Update</h1>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col col cols="12" sm="12" md="3" lg="3" class="text-left">
                      <h6>Complaint Type: </h6>
                    </b-col>
                    <b-col col cols="12" sm="3" md="3" lg="3" >

                      <select id="type" class="browser-default" name="officeType" style="background-color: #fafafa;" @change="">
                        <option value="0" disabled selected>Choose your option</option>
                        <!-- <option value="hq">Headquarter</option> -->
                        <option value="Bill Related">Bill Related</option>
                        <option value="Payment Related">Payment Related</option>
                        <option value="Prepaid Related">Prepaid Related</option>
                        <option value="Line Related">Line Related</option>
                        <option value="Service Connection Related">Service Connection Related</option>
                      </select>
                    </b-col>
                    <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                      <h6>Complaint Source: </h6>
                    </b-col>
                    <b-col col cols="12" sm="3" md="3" lg="3">
                      <select id="source" class="browser-default" name="officeName"  @change="" style="background-color: #fafafa;">
                        <option value="0" disabled selected>Choose your option</option>
                        <option value="Bijulee Bondhu">Bijulee Bondhu</option>
                        <option value="Support Mail">Support Mail</option>
                        <option value="On Premise">On Premise</option>
                      </select>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                      <h6>Complaint Description: </h6>
                    </b-col>
                    <b-col col cols="12" sm="3" md="9" lg="9">
                      <b-form-textarea
                        id="description"

                        placeholder="Enter Description..."
                        rows="3"
                        max-rows="12"
                      ></b-form-textarea>
                      </b-col>
                  </b-row><br>
                  <b-row>
                    <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                      <h6>Action Taken: </h6>
                    </b-col>
                    <b-col col cols="12" sm="3" md="9" lg="9">
                      <b-form-input id="action" placeholder="Enter Action Taken"></b-form-input>
                      </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col col cols="12" sm="12" md="3" lg="3" class="text-left">
                      <h6>Resolved Date: </h6>
                    </b-col>
                    <b-col col cols="12" sm="3" md="3" lg="3" >
                      <!-- <b-form-input id="resolved_date" placeholder="Enter Resolved Date"></b-form-input> -->
                      <b-form-datepicker id="example-datepicker" v-model="value" class="mb-2"></b-form-datepicker>
                        <p id="resolved_date" hidden>{{ value }}</p>
                    </b-col>
                    <b-col col cols="12" sm="3" md="2" lg="2" class="text-left">
                      <h6>Feedback: </h6>
                    </b-col>
                    <b-col col cols="12" sm="3" md="4" lg="4">
                      <b-form-input id="feedback" placeholder="Enter Feedback"></b-form-input>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col col cols="12" sm="12" md="2" lg="2" offset="4" class="text-center">
                      <b-button variant="info" @click="insertComplaint()">SUBMIT</b-button>
                    </b-col>
                    <b-col col cols="12" sm="12" md="2" lg="2" class="text-center">
                      <b-button variant="outline-danger">CANCEL</b-button>
                    </b-col>
                  </b-row>

            </b-col>
      </b-row>
      </b-container>
      <br><br>
</b-overlay>

      <b-modal   no-close-on-esc  no-close-on-backdrop   hide-header id="profilesuccessModal" centered  scrollable title="Complaint Update" hide-footer>
        <br><br><svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-180 0 500 130">
          <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
          <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
        </svg>
        <p class="success">Complaint Successfully Updated !<br><br>
        <b-button class="btn btn-outline" variant="success" id="" @click="reloadPage();" >OK</b-button>
        </p>
      </b-modal>
      <b-modal  no-close-on-esc  no-close-on-backdrop   hide-header id="profilefailureModal" centered  scrollable title="Complaint Update" hide-footer>
      <br><br>  <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-180 0 500 130">
          <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
        </svg>
        <p class="error">Complaint Update Failed ! <br><br>
          <b-button class="btn btn-outline" variant="danger" id="" @click="reloadPage();" >OK</b-button>
           </p>
      </b-modal>
  </div>
</template>

<script>
import AdminSideNav from '@/components/AdminSideNav.vue'
import HeaderConsumer from '@/components/HeaderConsumer.vue'
import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
import axios from 'axios'


var urlCommon = "http://localhost:8081/website";


export default {
  name: 'Admin',
  components: {
    'AdminSideNav' : AdminSideNav,
    'HeaderConsumer' : HeaderConsumer,
    'HeaderConsumerMobile' : HeaderConsumerMobile

  },
  data() {
      return {
        value: '',
        show: false,
      }
    },
  methods:
  {
    reloadPage()
    {
      window.location.reload();
    },
    insertComplaint(){
      var type = document.getElementById("type").value;
      var source = document.getElementById("source").value;
      var description = document.getElementById("description").value;
      var action = document.getElementById("action").value;
      var resolved_date = document.getElementById("resolved_date").innerHTML;
      var feedback = document.getElementById("feedback").value;

      console.log(type+"::"+source+"::"+description+"::"+action+"::"+resolved_date+"::"+feedback)

      if(type == "0"){
        this.$bvToast.toast('Please Select Complaint type !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("type").focus();
        return
      }
      if(source == "0"){
        this.$bvToast.toast('Please Select Source !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("source").focus();
        return
      }
      if(description == ""){
        this.$bvToast.toast('Please Enter Description !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("description").focus();
        return
      }

      if(action == ""){
        this.$bvToast.toast('Please Enter Action !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("action").focus();
        return
      }
      if(resolved_date == ""){
        this.$bvToast.toast('Please Enter Resolved Date !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
      //document.getElementById("resolved_date").focus();
        return
      }
      // if(feedback == ""){
      //   this.$bvToast.toast('Please Enter Feedback !', {
      //     title: `Error`,
      //     variant: 'danger',
      //     solid: true
      //   })
      //   document.getElementById("feedback").focus();
      //   return
      // }


   var parent = this;
   parent.show=true;
          axios.post(urlCommon + "/api/admin/putComplaintStatus?type="+type+"&source="+source+"&description="+description+"&action="+action+"&resolved_date="+resolved_date+"&feedback="+feedback).then(function(response) {
           parent.show=false;
            console.log (response.data )
            if(response.data=="success")
                parent.$bvModal.show('profilesuccessModal');
            else
                parent.$bvModal.show('profilefailureModal');



          });
    }
  },
  mounted()
  {
    var userId = localStorage.getItem("userId");
    var userName = localStorage.getItem("userName");
    var roles = localStorage.getItem("roleSet");
    if(userId==null)
      {
        this.$router.push({ path: '/' })
        return;
      }
    var i =0;
    var res= roles.split(",");

    for(i=0;i<res.length;i++)
     {
       document.getElementById(res[i]).style.display="block";
     }
     document.getElementById("consName").innerHTML = userName ;


  }

}


</script>

<style scoped="true">
body{
  overflow-y:hidden !important;
}

.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
  color: #0097a7 ;
}

li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
.shadow{}
  .headerF{
  display: block;
}
.headerM{
  display: none;
}
.sideNav{
  height:75vh;
  overflow-y:auto;
}
.dropdownmenu{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }
  @media (max-width: 576px) {
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }


    .path {
      stroke-dasharray: 1000;
      stroke-dashoffset: 0;
    }
    .path.circle {
      -webkit-animation: dash 0.9s ease-in-out;
      animation: dash 0.9s ease-in-out;
    }
    .path.line {
      stroke-dashoffset: 1000;
      -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
      animation: dash 0.9s 0.35s ease-in-out forwards;
    }
    .path.check {
      stroke-dashoffset: -100;
      -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
      animation: dash-check 0.9s 0.35s ease-in-out forwards;
    }

    p {
      text-align: center;
      margin: 20px 0 60px;
      font-size: 1.25em;
    }
    p.success {
      color: #73AF55;
    }
    p.error {
      color: #D06079;
    }
    @-webkit-keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @-webkit-keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }
    @keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }
</style>
